export default __webpack_public_path__ + "static/media/user.fcad900a.jpeg";